
import React from "react";
import SlideLayout from "../components/SlideLayout";

const ResultsSlide = () => {
  return (
    <SlideLayout>
      <div className="space-y-6">
        <div className="text-center">
          <h3 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 via-purple-600 to-pink-600 mb-4 font-cursive">Redefining E-commerce</h3>
          <p className="text-lg text-indigo-700 font-cursive max-w-3xl mx-auto leading-relaxed">
            Appella is redefining e-commerce with branded Conversational AI, 
            transforming static product listings into interactive, personalized
            experiences, and turning every visit into a high-return opportunity.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          <div className="bg-white backdrop-blur-sm border border-violet-300 p-6 rounded-xl shadow-sm hover:border-violet-400 transition-all">
            <h4 className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600 mb-2 font-cursive">Trust & Personalization</h4>
            <p className="text-indigo-700 text-sm font-cursive">
              Delivering brand-specific, customized shopping experiences that build consumer confidence.
            </p>
          </div>
          
          <div className="bg-white backdrop-blur-sm border border-indigo-300 p-6 rounded-xl shadow-sm hover:border-indigo-400 transition-all">
            <h4 className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-600 mb-2 font-cursive">Efficiency & Discovery</h4>
            <p className="text-indigo-700 text-sm font-cursive">
              Helping shoppers find the right products faster and with less effort.
            </p>
          </div>
          
          <div className="bg-white backdrop-blur-sm border border-fuchsia-300 p-6 rounded-xl shadow-sm hover:border-fuchsia-400 transition-all">
            <h4 className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600 mb-2 font-cursive">Customer-Centric Approach</h4>
            <p className="text-indigo-700 text-sm font-cursive">
              Making shopping more intuitive and seamless for today's consumers.
            </p>
          </div>
          
          <div className="bg-white backdrop-blur-sm border border-purple-300 p-6 rounded-xl shadow-sm hover:border-purple-400 transition-all">
            <h4 className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-violet-600 mb-2 font-cursive">Maximizing ROI</h4>
            <p className="text-indigo-700 text-sm font-cursive">
              Converting traffic into tangible revenue and reducing wasted media spend.
            </p>
          </div>
        </div>
        
        <div className="flex justify-center mt-8">
          <div className="bg-white backdrop-blur-sm border border-indigo-300 p-8 rounded-xl shadow-md max-w-3xl bg-gradient-to-br from-white to-violet-50">
            <p className="text-center text-transparent bg-clip-text bg-gradient-to-r from-violet-600 via-purple-600 to-pink-600 italic text-lg font-cursive">
              "The future of retail isn't just about what you sell, but how you engage with your customers. 
              Appella's AI transforms every interaction into a meaningful relationship."
            </p>
          </div>
        </div>
      </div>
    </SlideLayout>
  );
};

export default ResultsSlide;
